module.exports = __webpack_public_path__ + "img/IconoIman.6e15447b.png";